var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
// components
import iconMap from "../icons";
// styles
import { Wrapper } from "./wrapper.styles";
const iconComponent = Object.keys(iconMap).reduce((acc, cur) => {
    acc[cur.toLowerCase()] = iconMap[cur];
    return acc;
}, {});
export const Icon = (_a) => {
    var _b;
    var { symbol, width = "1rem", color, withHitSpace } = _a, restProps = __rest(_a, ["symbol", "width", "color", "withHitSpace"]);
    useEffect(() => {
        const iconName = symbol.toLowerCase();
        const Element = iconComponent[iconName];
        if (!Element) {
            console.warn(`Icon "${iconName}" not found, maybe you have made a spelling mistake?"`);
            return;
        }
        if (Element.changed) {
            console.warn(`Icon "${iconName}" ist changed, please use "${Element.alternative}" instead.`);
        }
        if (Element.deprecated) {
            console.warn(`Icon "${iconName}" ist deprecated and will be removed in the future.`);
        }
    }, [symbol]);
    const Element = iconComponent[symbol.toLowerCase()];
    if (!Element) {
        return _jsx("span", Object.assign({ className: "no-icon" }, { children: "?" }));
    }
    return (_jsx(Wrapper, Object.assign({ width: width, color: color, withHitSpace: withHitSpace }, restProps, { 
        // the order is important here, because the user can pass a className
        className: `icon ${(_b = restProps.className) !== null && _b !== void 0 ? _b : ""}` }, { children: _jsx(Element, {}) })));
};
Icon.displayName = "Icon";
